export function getBidColor(alpha: number): string {
  return `rgba(39, 174, 96, ${alpha})`;
}

export function getAskColor(alpha: number): string {
  return `rgba(192, 57, 43, ${alpha})`;
}
